import { COMPANY_NAME_MAX_LENGTH, COMPANY_NAME_MIN_LENGTH } from '@/users/domain/company/Company';
import { validateMaxLength } from '@/Framework/UI/Organisms/FinalForm/validators/validateMaxLength';
import { validateMinLength } from '@/Framework/UI/Organisms/FinalForm/validators/validateMinLength';
import { IValidationError } from '../interfaces/ValidationError';

interface IParams {
  value: string,
  fieldName: string,
  fieldCaption: string,
}

export const validateCompanyName = (params: IParams): IValidationError => {
  const minLengthError = validateMinLength({ ...params, length: COMPANY_NAME_MIN_LENGTH });
  if (minLengthError) {
    return minLengthError;
  }
  const maxLengthError = validateMaxLength({ ...params, length: COMPANY_NAME_MAX_LENGTH });
  if (maxLengthError) {
    return maxLengthError;
  }
  return null;
};
